import { StaticBaseDao } from '@/dao';
import {
    BibAssignSaveRequest,
    BibAssignSaveResponse,
    PostResponse,
    BibAssignPreview,
    ReportBibAssignPreviewRequest,
    SetSeedingGroupRequest,
} from '@/objects/generated';

export class BibAssignDao extends StaticBaseDao {
    public static async SaveBibAssign(eventId: number, request: BibAssignSaveRequest): Promise<BibAssignSaveResponse | null> {
        return this.BaseFetch(
            BibAssignSaveResponse,
            `BibAssign/SaveBibAssign` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'POST',
            request,
        );
    }
    public static async BibAssignBuild(
        eventId: number,
        keepAssigned: boolean,
        shuffle: boolean,
        overwriteStarttimes: boolean,
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `BibAssign/BibAssignBuild` +
                '?' +
                (eventId == undefined ? '' : `eventId=${eventId}`) +
                '&' +
                (keepAssigned == undefined ? '' : `keepAssigned=${keepAssigned}`) +
                '&' +
                (shuffle == undefined ? '' : `shuffle=${shuffle}`) +
                '&' +
                (overwriteStarttimes == undefined ? '' : `overwriteStarttimes=${overwriteStarttimes}`),
            'POST',
        );
    }
    public static async BibAssignPreview(
        eventId: number,
        keepAssigned: boolean,
        shuffle: boolean,
        overwriteStarttimes: boolean,
    ): Promise<BibAssignPreview[]> {
        return this.BaseFetchArray(
            BibAssignPreview,
            `BibAssign/BibAssignPreview` +
                '?' +
                (eventId == undefined ? '' : `eventId=${eventId}`) +
                '&' +
                (keepAssigned == undefined ? '' : `keepAssigned=${keepAssigned}`) +
                '&' +
                (shuffle == undefined ? '' : `shuffle=${shuffle}`) +
                '&' +
                (overwriteStarttimes == undefined ? '' : `overwriteStarttimes=${overwriteStarttimes}`),
            'POST',
        );
    }
    public static async BibAssignPreviewWithGraphics(
        eventId: number,
        req: ReportBibAssignPreviewRequest,
    ): Promise<{ stream: ReadableStream<Uint8Array> | null; contentType: string | null; filename?: string }> {
        return this.PostRaw(`BibAssign/BibAssignPreviewWithGraphics` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`), req);
    }
    public static async BibAssignSetSeedingGroups(eventId: number, request: SetSeedingGroupRequest): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `BibAssign/BibAssignSetSeedingGroups` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'POST',
            request,
        );
    }
    public static async SetEmitTagOnAll(eventId: number): Promise<PostResponse | null> {
        return this.BaseFetch(PostResponse, `BibAssign/SetEmitTagOnAll` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`), 'POST');
    }
}
